"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atatUrl = void 0;
const config_1 = require("../config");
exports.atatUrl = `${config_1.atatApiUrl}/api/visitor/page-load`;
//# sourceMappingURL=atat.js.map